import request from '@/utils/request'
// 热门游戏
export function getHotGameList(data) {
    return request({
        url: '/webshop/api/gw/account/getHotGameList',
        method: 'get',
        params:data
    })
}
// 首页游戏
export function getGameList() {
    return request({
        url: '/webshop/api/gw/web/getGameList',
        method: 'get',
    })
}
// 根据id获取游戏详情
export function getGameById(data) {
    return request({
        url: '/webshop/api/gw/web/getGameById',
        method: 'get',
        params:data
    })
}
// 玩过的游戏
export function getPlayGameList() {
    return request({
        url: '/webshop/api/gw/account/getGameList',
        method: 'get',
    })
}

// 根据游戏获取区服
export function getServerById(data) {
    return request({
        url: '/webshop/api/gw/account/getServer',
        method: 'get',
        params:data
    })
}

// 根据游戏角色
export function getRolesByGameId(data) {
    return request({
        url: '/webshop/api/gw/account/getRolesByGameId',
        method: 'get',
        params:data
    })
}



// WEBPACK FOOTER //
// ./src/api/gameList.js